<template>
  <div class="detail" v-loading="loading">
    <div class="head">
      <div class="title-wrap">
        <div class="title-name">发布活动</div>
        <div class="title-desc">你可把活动发布至「联机大厅-活动」中，让更多的玩家参与你的活动，准入门槛可见<a class="title-link" :href="actRuleLink" target="_blank">《活动申请教程》</a></div>
      </div>
    </div>
    <el-form
      :model="form.data"
      :rules="form.rules"
      ref="form"
      @submit.native.prevent="submit"
      label-width="136px">
      <el-form-item prop="pid" label="动态ID">
        <el-input v-model="form.data.pid" :disabled="type === 'edit'"></el-input>
      </el-form-item>
      <el-form-item prop="atype" label="活动类型">
        <el-radio-group
            v-model="form.data.atype"
            :disabled="type === 'edit'"
          >
            <el-radio :label="1">游戏内福利</el-radio>
            <el-radio :label="2">抽奖</el-radio>
            <el-radio :label="3">其他活动</el-radio>
          </el-radio-group>
      </el-form-item>
      <el-form-item prop="name" label="活动名称">
        <el-input v-model="form.data.name"></el-input>
      </el-form-item>
      <el-form-item prop="desc" label="活动描述">
        <el-input v-model="form.data.desc"></el-input>
      </el-form-item>
      <el-form-item prop="award" label="平台活动奖励">
        <div>
          <div class="award-item" v-for="(item, index) in form.data.award" :key="index">
            <el-form-item :prop="`award.${index}.id`" :rules="{ required: true, message: '请选择奖励道具' }">
              <el-select v-model="item.id" placeholder="奖励道具" style="width: 120px" clearable>
                <el-option label="迷你币" :value="10002"></el-option>
                <el-option label="迷你豆" :value="10000"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :prop="`award.${index}.num`" :rules="[{ required: true, message: '请输入道具数量' }, { validator: checkAwardNum }]" style="margin-left: 15px;">
              <el-input-number v-model="item.num" placeholder="道具数量"></el-input-number>
            </el-form-item>
            <el-button type="text" @click="delAward(index)" style="margin-left: 15px;">删除</el-button>
          </div>
          <el-button type="text" @click="addAward">新增奖励</el-button>
        </div>
        <!-- <el-input v-model="form.data.award"></el-input> -->
      </el-form-item>
      <el-form-item prop="other_award" label="其他活动奖励">
        <el-input v-model="form.data.other_award"></el-input>
      </el-form-item>
      <el-form-item prop="time_str" label="活动时间">
        <el-input v-model="form.data.time_str"></el-input>
      </el-form-item>
      <el-form-item prop="time_range" label="卡片展示时间">
        <el-date-picker
          v-model="form.data.time_range"
          :disabled="type === 'edit'"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="reason" label="发布活动原因">
        <el-input v-model="form.data.reason"></el-input>
      </el-form-item>
      <el-button type="primary" native-type="submit">
        保存并发布
      </el-button>
      <el-button @click="goBack">
        取消
      </el-button>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { GetPidDetail, AddAct, EditAct } from '@/api/publishAct.js';
const maxTimeRange = (rule, value, callback) => {
  const maxDay = 8;
  const maxTime = maxDay * 60 * 60 * 24 * 1000;
  const diffTime = value[1] - value[0];
  if (diffTime > maxTime) {
    callback(new Error('卡片展示时间最多只能选择8天'));
    return;
  } else if (value[1] <= value[0]) {
    callback(new Error('结束时间必须大于开始时间'));
    return;
  }
  callback();
};
const createDefaultTime = () => {
  const today = new Date().setHours(0, 0, 0, 0);
  const start = today + 1 * 60 * 60 * 24 * 1000;
  const end = today + 8 * 60 * 60 * 24 * 1000;
  return [start, end];
};

function getByteSize(str) {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (code <= 0x7f) {
          len += 1;
      } else if (code <= 0x7ff) {
          len += 2;
      } else if (code >= 0xd800 && code <= 0xdfff) {
          // surrogate pair
          len += 4;
          i++; // 跳过配对的代理项
      } else {
          len += 3;
      }
  }
  return len;
}
const validateText = (max) => {
  return (rule, value, callback) => {
    const textNum = getByteSize(value);
    if (textNum > max) {
      callback(new Error(`最多输入${max}个英文字符，1中文=3个英文字符=3个数字`));
      return;
    }
    callback();
  };
};
export default {
  data() {
    return {
      type: this.$route.query.type,
      id: this.$route.query.id,
      loading: false,
      actRuleLink: 'https://dev-wiki.mini1.cn/article/673ff10dd07d9b268819de96',
      form: {
        data: {
          pid: '',
          nick_name: this.$store.state.developerInfo.nickname,
          atype: 1,
          name: '',
          desc: '',
          award: [],
          other_award: '',
          time_str: '',
          time_range: createDefaultTime(),
          reason: '',
        },
        rules: {
          pid: [{ required: true, message: '请输入动态ID' }, { min: 1, max: 100, message: '长度在 1 到 100 个字符' }],
          atype: [{ required: true, message: '请选择活动类型' }],
          name: [{ required: true, message: '请输入活动名称' }, { validator: validateText(30) }],
          desc: [{ required: true, message: '请输入活动描述' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符' }],
          award: [{ type: 'array', }],
          other_award: [{ min: 0, max: 20, message: '长度在 0 到 20 个字符' }],
          time_str: [{ required: true, message: '请输入活动时间' }, { validator: validateText(20) }],
          time_range: [{ type: 'array', required: true, message: '请选择卡片展示时间' }, { validator: maxTimeRange }],
          reason: [{ required: true, message: '请输入发布活动原因' }, { min: 1, max: 100, message: '长度在 1 到 200 个字符' }],
        }
      }
    };
  },
  computed: {
    ...mapState(['developerInfo']),
  },
  watch: {
    'developerInfo.nickname'(val) {
      if (!this.form.data.nick_name) {
        this.form.data.nick_name = val;
      }
    }
  },
  created() {
    if (this.type === 'edit') {
      this.getDetail();
    }
  },
  methods: {
    addAward() {
      this.form.data.award.push({ id: '', num: '' });
    },
    delAward(index) {
      this.form.data.award.splice(index, 1);
    },
    async submit() {
      await this.$refs.form.validate();
      const data = this.form.data;
      const params = {
        pid: data.pid,
        nick_name: data.nick_name,
        atype: data.atype,
        name: data.name,
        desc: data.desc,
        award: JSON.stringify(data.award),
        other_award: data.other_award,
        time_str: data.time_str,
        card_start_time: Math.floor(data.time_range[0] / 1000),
        card_end_time: Math.floor(data.time_range[1] / 1000),
        reason: data.reason,
        json: 1,
      };
      const reqMap = {
        add: AddAct,
        edit: EditAct,
      };
      const req = reqMap[this.type];
      if (this.type === 'edit') {
        params.id = this.id;
      }
      try {
        this.loading = true;
        const res = await req(params);
        this.loading = false;
        if (res.code !== 0) {
          return;
        }
        this.$message.success('操作成功');
        this.goBack();
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
    async getDetail() {
      const params = {
        id: this.id,
      };
      try {
        this.loading = true;
        const res = await GetPidDetail(params);
        this.loading = false;
        if (res.code !== 0) {
          return;
        }
        const data = res.data;
        this.form.data.pid = data.pid;
        this.form.data.atype = data.atype;
        this.form.data.name = data.name;
        this.form.data.desc = data.desc;
        if (data.award) {
          try {
            this.form.data.award = JSON.parse(data.award);
          } catch (error) {
            console.log(error);
          }
        }
        this.form.data.other_award = data.other_award;
        this.form.data.time_str = data.time_str;
        this.$set(this.form.data.time_range, 0, data.card_start_time * 1000);
        this.$set(this.form.data.time_range, 1, data.card_end_time * 1000);
        this.form.data.reason = data.reason;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
    goBack() {
      this.$router.replace({ name: 'PublishActIndex' });
    },
    checkAwardNum(rule, value, callback) {
      if (!(value >= 1)) {
        callback(new Error('请输入道具数量'));
        return;
      }
      callback();
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  .head {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 24px;
    color: #595959;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    margin-bottom: 24px;
    .title-wrap {
      .title-desc {
        font-size: 14px;
        color: #8c8c8c;
        margin-top: 8px;
        .title-link {
          color: #2b6ddf;
          text-decoration: none;
        }
      }
    }
  }
  .award-item {
    margin-bottom: 20px;
    display: flex;
  }
}
</style>
